/* eslint-disable */
export default (() => {
  const btnSearchMobile = $('.js-btn-search-icon');
  const btnSearchIcon = $('.js-btn-search-icon');
  const searchBox = $('.header__searchbox');
  const btnBurger = $('.js-burger');
  const btnBurgerIcon = $('.js-btn-burger-icon');
  const offCanvas = $('.off-canvas');
  const toggleSearch = () => {
    // eslint-disable-next-line no-console

    $(searchBox).toggleClass('header__searchbox--is-active');
    if (offCanvas.hasClass('off-canvas--is-active')) {
      toggleMenu();
    }
  };
  const toggleMenu = () => {
    offCanvas.toggleClass('off-canvas--is-active');
    if (offCanvas.hasClass('off-canvas--is-active')) {
      btnBurgerIcon.text('close');
    } else {
      btnBurgerIcon.text('menu');
    }
  };
  btnSearchMobile.on('click', function () {
    toggleSearch();
  });
  btnBurger.on('click ', function () {
    toggleMenu();
  });
  $('.menu-item-has-children > a').on('click', function () {
    const listItem = jQuery(this).parent();
    const subMenu = listItem.children('.sub-menu');
    subMenu.toggleClass('sub-menu--is-active');
    listItem.toggleClass('is-collapsed');
  });
});